import styled from "styled-components";
import { Column, theme } from "uikit";

const Background = styled(Column)`
	background: ${theme.colors.button_secondary};
`;

export default Background;
